// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDxLo6Dj0MvZK_nhvNxgb1aRdBTxfnMzZg",
    authDomain: "quote-builder-cd0e9.firebaseapp.com",
    projectId: "quote-builder-cd0e9",
    storageBucket: "quote-builder-cd0e9.appspot.com",
    messagingSenderId: "651148701273",
    appId: "1:651148701273:web:e9c3cac88b019f5881cb48"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
// Initialize Firebase services
export const auth = getAuth(firebaseApp); // For Firebase Authentication
export const db = getFirestore(firebaseApp); // For Firestore database

// Optionally, export the firebaseApp instance if needed
export default firebaseApp;